import {
    Box,
    Button,
    chakra,
    Icon,
    HStack,
    Menu,
    MenuButton,
    VStack,
    MenuList,
    MenuItem,
    Text,
    IconButton,
    WrapItem,
    Wrap,
    Tag,
    TagLabel,
    TagLeftIcon,
    TagCloseButton,
    Tooltip,
} from '@chakra-ui/react';
import TextareaAutosize from 'react-textarea-autosize';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { BsArrowRightShort } from 'react-icons/bs';
import { ReportingShellViewBaseConfig } from '../../../../base';
import { ChatComposerViewProps } from './chatComposerProps';

export function createChatComposerView(
    config: ReportingShellViewBaseConfig & {}
): React.FC<ChatComposerViewProps> {
    const ChakraTextareaAutosize = chakra(TextareaAutosize, {
        baseStyle: {},
    });
    return (props) => {
        return (
            <VStack
                p={{ base: 3, '2xl': 4 }}
                w="full"
                align="start"
                spacing={4}
                borderRadius="lg"
                position="relative"
                bg="whiteAlpha.50"
            >
                {props.context && (
                    <Wrap shouldWrapChildren={true} spacing={1}>
                        {props.context.items.map((item) => (
                            <Tooltip
                                {...item.tooltip}
                                placement="top"
                                openDelay={300}
                                key={item.id}
                                px={2}
                                py={1}
                                bg="gray.50"
                                color="gray.900"
                                borderRadius="md"
                                closeOnClick={false}
                                shouldWrapChildren={true}
                            >
                                <Tag
                                    key={item.id}
                                    as={HStack}
                                    maxW="12rem"
                                    size="sm"
                                    borderColor="whiteAlpha.200"
                                    borderWidth={1}
                                    color="whiteAlpha.500"
                                    spacing={0}
                                    bg="none"
                                    cursor="default"
                                >
                                    {item.Icon && <TagLeftIcon as={item.Icon} />}
                                    <TagLabel noOfLines={1}>{item.label}</TagLabel>
                                    <TagCloseButton fontSize="xs" />
                                </Tag>
                            </Tooltip>
                        ))}
                    </Wrap>
                )}
                <ChakraTextareaAutosize
                    {...props.input}
                    ref={props.inputRef}
                    w="full"
                    lineHeight={1.25}
                    autoFocus={true}
                    minRows={1}
                    maxRows={8}
                    border="none"
                    bg="none"
                    tabIndex={1}
                    resize="none"
                    placeholder="Plan, search or ask anything"
                    sx={{ caretColor: 'whiteAlpha.800' }}
                    _disabled={{
                        color: 'whiteAlpha.500',
                        cursor: 'default',
                    }}
                    _placeholder={{
                        color: 'whiteAlpha.400',
                    }}
                    _focus={{
                        outline: 'none',
                    }}
                    _focusVisible={{
                        outline: 'none',
                    }}
                />
                <HStack w="full" justify="space-between" align="end">
                <HStack flexShrink={0}>
                    {props.mode && (
                        
                            <Menu
                                placement="top"
                                boundary="clippingParents"
                                autoSelect={false}
                            >
                                <MenuButton
                                    as={Button}
                                    size="xs"
                                    color="whiteAlpha.600"
                                    minH={6}
                                    h={6}
                                    px={2}
                                    bg="whiteAlpha.50"
                                    _hover={{
                                        bg: 'whiteAlpha.100',
                                    }}
                                    _expanded={{
                                        bg: 'whiteAlpha.100',
                                    }}
                                    borderRadius="full"
                                    iconSpacing={1}
                                    leftIcon={
                                        <Icon
                                            color="whiteAlpha.500"
                                            fontSize="sm"
                                            as={props.mode.Icon}
                                        />
                                    }
                                    rightIcon={
                                        <Icon
                                            color="whiteAlpha.500"
                                            fontSize="md"
                                            as={ChevronDownIcon}
                                        />
                                    }
                                >
                                    {props.mode.label}
                                </MenuButton>
                                <MenuList w="20rem" bg="black" p={0} overflow="hidden">
                                    <VStack
                                        align="start"
                                        w="full"
                                        bg="whiteAlpha.200"
                                        p={1}
                                        spacing={0}
                                    >
                                        {props.mode.options.map((option) => (
                                            <MenuItem
                                                key={option.id}
                                                {...option.button}
                                                borderRadius="md"
                                                py={1}
                                                fontSize="sm"
                                                fontWeight="medium"
                                                color="whiteAlpha.800"
                                                alignItems="start"
                                                icon={
                                                    option.Icon ? (
                                                        <Icon
                                                            position="relative"
                                                            top={1}
                                                            fontSize="lg"
                                                            as={option.Icon}
                                                        />
                                                    ) : undefined
                                                }
                                                _hover={{
                                                    bg: 'whiteAlpha.50',
                                                }}
                                            >
                                                <VStack
                                                    align="start"
                                                    spacing={0}
                                                    fontSize="xs"
                                                >
                                                    <Text
                                                        fontWeight="semibold"
                                                        color="whiteAlpha.800"
                                                    >
                                                        {option.label}
                                                    </Text>
                                                    <Text
                                                        color="whiteAlpha.500"
                                                        noOfLines={2}
                                                    >
                                                        {option.description}
                                                    </Text>
                                                </VStack>
                                            </MenuItem>
                                        ))}
                                    </VStack>
                                </MenuList>
                            </Menu>
                    )}
                    {props.assistantMode && (
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    size="xs"
                                    color="whiteAlpha.600"
                                    minH={6}
                                    h={6}
                                    px={2}
                                    bg="whiteAlpha.50"
                                    _hover={{
                                        bg: 'whiteAlpha.100',
                                    }}
                                    _expanded={{
                                        bg: 'whiteAlpha.100',
                                    }}
                                    borderRadius="full"
                                    iconSpacing={1}
                                    leftIcon={
                                        <Icon
                                            color="whiteAlpha.500"
                                            fontSize="sm"
                                            as={props.assistantMode.Icon}
                                        />
                                    }
                                    rightIcon={
                                        <Icon
                                            color="whiteAlpha.500"
                                            fontSize="md"
                                            as={ChevronDownIcon}
                                        />
                                    }
                                >
                                    {props.assistantMode.label}
                                </MenuButton>
                                <MenuList w="20rem" bg="black" p={0} overflow="hidden">
                                    <VStack align="start" w="full" bg="whiteAlpha.200" p={1} spacing={0}>
                                        {props.assistantMode.options.map((option) => (
                                            <MenuItem key={option.id} {...option.button} borderRadius="md" py={1} fontSize="sm" fontWeight="medium" color="whiteAlpha.800" alignItems="start" icon={option.Icon ? <Icon position="relative" top={1} fontSize="lg" as={option.Icon} /> : undefined} _hover={{ bg: 'whiteAlpha.50' }}>
                                                <VStack align="start" spacing={0} fontSize="xs">
                                                    <Text fontWeight="semibold" color="whiteAlpha.800">{option.label}</Text>
                                                    <Text color="whiteAlpha.500" noOfLines={2}>{option.description}</Text>
                                                </VStack>
                                            </MenuItem>
                                        ))}
                                    </VStack>
                                </MenuList>
                            </Menu>
                    )}
                        </HStack>

                    <IconButton
                        {...props.submit.button}
                        aria-label="Send"
                        icon={
                            <Icon
                                fontSize={{ base: 'xl', '2xl': '2xl' }}
                                as={BsArrowRightShort}
                            />
                        }
                        // size={{ base: 'xs', '2xl': 'sm' }}
                        minW={{ base: 7, '2xl': 8 }}
                        w={{ base: 7, '2xl': 8 }}
                        h={{ base: 7, '2xl': 8 }}
                        p={0}
                        borderRadius="full"
                        bg="white"
                        color="black"
                        _hover={{
                            bg: 'whiteAlpha.900',
                        }}
                        _disabled={{ opacity: 0.3, cursor: 'default' }}
                    />
                </HStack>
            </VStack>
        );
    };
}
